<template>
  <v-list-group v-if="notification" v-model="expanded">
    <template #appendIcon>
      <v-icon small>far fa-chevron-down</v-icon>
    </template>

    <template #activator>
      <v-list-item-avatar>
        <v-avatar color="primary">
          <v-icon small class="white--text" :title="iconTitle">{{icon}}</v-icon>
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          <Notification :notification="notification" :secondary="!expanded" />
        </v-list-item-title>
        <v-list-item-subtitle>
          <small>
            <template v-if="notification.data.room">
              <i>{{notification.data.room.name || notification.data.room.id}}</i>,
            </template>
            <span :title="created">{{fromNow}}</span>
          </small>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-list-item>
      <div class="py-2 w-100">
        <Notification :notification="notification" detail />
        <Notification
          :notification="notification"
          actions
          class="d-flex justify-end"
        />
      </div>
    </v-list-item>
  </v-list-group>
</template>

<script>
  import moment from 'moment';

  import Notification from './Notification';
  import {icon} from './notification-utils';
  import {getDeviceName} from '../peers/peer-utils';


  export default {
    name: 'NotificationItem',

    components: {
      Notification
    },

    props: {
      notification: {
        type: Object,
        default: () => null
      },
      value: {
        type: Boolean,
        default: false
      },
      visible: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      expanded: false,
      fromNow: null
    }),

    computed: {
      peer() {
        return this.notification?.data?.peer;
      },

      icon() {
        return icon(this.notification);
      },

      iconTitle() {
        return this.peer ? getDeviceName(this.peer) : '';
      },

      created() {
        return moment(this.notification?.created).format('L[,] LT');
      }
    },

    watch: {
      value(value) {
        this.expanded = value;
      },

      visible(visible) {
        if (visible) {
          this._updateFromNow();
          this._fromNowInterval = setInterval(() => this._updateFromNow(), 10000);
        } else {
          clearInterval(this._fromNowInterval);
        }
      },

      notification(notification) {
        if (notification) {
          this._updateFromNow();
        }
      }
    },

    mounted() {
      this.expanded = this.value;
      this._updateFromNow();
    },

    destroyed() {
      clearInterval(this._fromNowInterval);
    },

    methods: {
      _updateFromNow() {
        this.fromNow = moment(this.notification?.created).fromNow();
      }
    }
  };
</script>
